import React from "react";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { useStores } from "@stores";
import { Navigate } from "react-router-dom";
import { ROUTES } from "@stores/AccountStore";
import { ContextProvider } from "@stores/SeasonStore";
import { ContextProvider as FarmContextProvider } from "@stores/FarmStore";
import Spinner from "@components/Spinner";
import { canOpenRoute } from "@src/utils/navigation";

const LoadingLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  inset: 0;
  background: rgba(256, 256, 256, 0.5);
`;


interface IProps {
  /**
   * The route being guarded. When the account may not open it (utils/
   * navigation ROUTE_CAPABILITY — a team role without fields or machines, the
   * paid owner-only agent), land on the account's home instead of rendering a
   * screen whose every call fails.
   */
  route?: ROUTES;
}

const PrivateRoute: React.FC<IProps> = ({ children, route }) => {
  const { accountStore } = useStores();

  if (!accountStore.initialized) {
    return (
      <LoadingLayout>
        <Spinner />
      </LoadingLayout>
    );
  }

  if (accountStore.authenticated) {
    if (route && !canOpenRoute(accountStore, route)) {
      return <Navigate to={accountStore.homeRoute} replace />;
    }
    return (
      <ContextProvider>
        <FarmContextProvider>{children}</FarmContextProvider>
      </ContextProvider>
    );
  }

  return <Navigate to={ROUTES.LOGIN} />;
};
export default observer(PrivateRoute);
